import styled from 'styled-components';

export const WarningContainer = styled.div`
  display: flex;
  align-items: center;
`;
